// reducers/metaReducer.js

export const initialMetaState = {
    accommodation: [],
    safariSession: [],
    metaLoading: true
};

export const metaReducer = (state = initialMetaState, action) => {
    switch (action.type) {
        case "SET_META_LOADING":
            return {
                ...state,
                metaLoading: typeof action.payload === "boolean" ? action.payload : state.metaLoading,
            };
        case 'SET_META_ACCOMMODATION':
            return {
                ...state,
                accommodation: Array.isArray(action.payload) ? action.payload : state.accommodation,
            };
        case 'SET_META_SAFARI_SESSION':
            return {
                ...state,
                safariSession: Array.isArray(action.payload) ? action.payload : state.safariSession,
            };
        default:
            return state;
    }
};
